var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrodownImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92859 7.20182L9.73125 1.64721C9.90699 1.39068 10 1.13222 10 0.917385C10 0.502044 9.66666 0.245117 9.10869 0.245117L0.890017 0.245117C0.332694 0.245117 -1.12165e-08 0.50172 -2.93292e-08 0.91609C-3.8734e-08 1.13125 0.09309 1.38558 0.269312 1.64267L4.0719 7.19988C4.31684 7.55726 4.64646 7.75518 5.00045 7.75518C5.35419 7.75526 5.68372 7.55961 5.92859 7.20182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrodownImage);
export default __webpack_public_path__ + "static/media/drodownImage.cfc5b4a3623c9608185b6448f280bfaf.svg";
export { ForwardRef as ReactComponent };